module.exports = __webpack_public_path__ + "img/Alerte.876991c6.png";